import {
  RolesState,
  LOAD_ROLES,
  LOAD_ROLES_SUCCESS,
  RolesActionTypes,
  TRANSFORM_ROLES,
  SELECT_GROUP,
  Role,
} from "./types";

const transformName = roleName => {
  roleName = roleName.replace('rep', 'Report').replace('ta-', 'TA ').replace('lm-', 'LM ').replace('tg-', 'TG ').replace('sfp-', 'SFP ');
  return roleName.split('-').join(' ');
}

const initialState: RolesState = {
  loading: false,
  loadingRoles: false,
  roles: [],
  rolesGrouped: [],
  selectedGroup: null,
  selectedGroupName: ''
};

export const rolesReducer = (
  state = initialState,
  action: RolesActionTypes
): RolesState => {
  switch (action.type) {
      case LOAD_ROLES:
        return {
          ...state,
          loading: true
        }
      case LOAD_ROLES_SUCCESS:
          return {
              ...state,
              loading: false,
              roles: action.payload
          };
      case TRANSFORM_ROLES:
          let roles = action.payload;
          let rolesGrouped = {};

          for(let role of roles) {
            let splitted = role.GroupName.split('_');
            const last = splitted.pop();
            const [first, second] = splitted;
            const key = transformName(`${first} ${second ? second : ''}`);

            if(!rolesGrouped[key]) {
              rolesGrouped[key] = [];
            }

            role.prettyName = last?.replace(/-/gi,' ');
            rolesGrouped[key].push(role)
          }
          return {
              ...state,
              rolesGrouped: rolesGrouped
          }

      case SELECT_GROUP:
          return {
            ...state,
            selectedGroup: action.payload.groups,
            selectedGroupName: action.payload.name
          }
    default:
      return state;
  }
}
